require('./brokerStocksAdvancedSellView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('commonsComponents/OKButton');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const OKBadge = require('components/commons/OKBadge/OKBadge');

// @ components
const BrokerStocksHeader = require('components/broker/brokerProductHeaders/brokerStocksHeader/brokerStocksHeader');
const {
    BrokerStocksAdvancedSellStep1
} = require('components/broker/brokerStocksAdvancedSell/brokerStocksAdvancedSellStep1/brokerStocksAdvancedSellStep1');
const {
    BrokerStocksAdvancedSellStep2
} = require('components/broker/brokerStocksAdvancedSell/brokerStocksAdvancedSellStep2/brokerStocksAdvancedSellStep2');
const BrokerStocksAdvancesSellStep3 = require('components/broker/brokerStocksAdvancedSell/brokerStocksAdvancedSellStep3/brokerStocksAdvancedSellStep3');
const BrokerStocksAdvancedSellSuccess = require('components/broker/brokerStocksAdvancedSell/brokerStocksAdvancedSellSuccess/brokerStocksAdvancedSellSuccess');

// @ actions
const BrokerStocksAdvancedSellActions = require('actions/brokerStocksAdvancedSell');
const ProductFileActions = require('actions/brokerGetProductFile.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');
const WebappRender = require('components/conditionalRender/webappRender')

// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    COLLECTIVOS_STOCKS_ADVANCE_SELL_LOCATION,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    BROKER_SELL_SCREEN
} = require('constants/index');

// @ helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

class BrokerStocksAdvancedSellView extends React.Component {
    constructor(props) {
        super(props);
        this.buildWizard = this.buildWizard.bind(this);
        this.buildSuccessful = this.buildSuccessful.bind(this);
        this.getProductDetails = this.getProductDetails.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const { match: { params }, setOrderID, immProfile, history } = this.props;

        this.getProductDetails();
        setOrderID(params.isin, params.iso);
        this.props.fetchOpenTraderLink();

        if (immProfile.get('isCollective')) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVOS_STOCKS_ADVANCE_SELL_LOCATION, history);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { setLimitedValueCurrency } = this.props;
        const nextCurrency = nextProps.immProductFile.getIn(['productValue', 'currency']);
        const currentCurrency = this.props.immProductFile.getIn(['productValue', 'currency']);

        if (nextCurrency !== currentCurrency) {
            setLimitedValueCurrency(nextCurrency);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    getBreadcrumbData(productFile, isin, iso, emisionCode, valueCode) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/productFile/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerStocksSell'),
                url: `/myprofile/broker/stocksSell/${isin}/${iso}/${emisionCode}/${valueCode}`
            },
            {
                text: formatText('breadcrumb-brokerAdvancedOrder')
            }
        ];
    }

    getProductDetails() {
        const { getProductDetails, match: { params: { isin, iso } } } = this.props;
        getProductDetails(isin, iso, BROKER_SELL_SCREEN);
    }

    buildSuccessful() {
        const {
            immBrokerStocksAdvancedSell,
            immStocksContract,
            immProductFile,
            immSearchState
        } = this.props;

        return (
            <div className="row no-gutter">
                <BrokerStocksAdvancedSellSuccess
                    immProductFile={immProductFile}
                    immBrokerStocksAdvancedSell={immBrokerStocksAdvancedSell}
                    immStocksContract={immStocksContract}
                    immSearchState={immSearchState}
                />
            </div>
        );
    }

    buildWizard() {
        const {
            immBrokerStocksAdvancedSell,
            immCollectivesCommissions,
            immStocksContract,
            immProductFile,
            immProfile,
            immSearchState,
            immVariables,
            match: { params }
        } = this.props;
        const immSteps = immBrokerStocksAdvancedSell.get('steps');
        const visibleStep = immBrokerStocksAdvancedSell.get('visibleStep');
        const firstStepLoading = immBrokerStocksAdvancedSell.getIn([
            'steps',
            FIRST_STEP,
            'loading'
        ]);
        const secondStepLoading = immBrokerStocksAdvancedSell.getIn([
            'steps',
            SECOND_STEP,
            'loading'
        ]);
        const thirdStepLoading = immBrokerStocksAdvancedSell.getIn([
            'steps',
            THIRD_STEP,
            'loading'
        ]);
        const actions = {
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: this.props.finish,
            validateStep: this.props.validateStep,
            cancel: this.handleCancel
        };
        const isCollectiveUser = !!immProfile.get('isCollective');
        const headerMenuData = {
            title: formatText('broker-stocksAdvancedSellWizardTitle'),
            linksData: []
        };

        if (isCollectiveUser) {
            const commisionsLink = immCollectivesCommissions && immCollectivesCommissions.get('url');
            headerMenuData.extraContent = <OKBadge toUrl={commisionsLink} target={'_blank'} name={formatText('broker-stocksAdvancedSellWizardBadgeLabel').toUpperCase()} />;
        } else {
            const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
            headerMenuData.linksData.push({
                label: formatText('broker-stocksAdvancedSellWizardFirstLinkLabel'),
                href: fees_url,
                hasTooltip: false,
                target: '_blank'
            });
        }

        return (
            <Wizard
                wizardClass={'broker-stocks-advanced-buy__wizard'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={firstStepLoading}
                >
                    <BrokerStocksAdvancedSellStep1 />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    addLoadingBehaviour={false}
                    isLoading={secondStepLoading}
                >
                    <BrokerStocksAdvancedSellStep2
                        immBrokerStocksAdvancedSell={immBrokerStocksAdvancedSell}
                        immStocksContract={immStocksContract}
                        isin={params.isin}
                        iso={params.iso}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-stocksAdvancedSellFinish"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={thirdStepLoading}
                >
                    <BrokerStocksAdvancesSellStep3
                        immProductFile={immProductFile}
                        immBrokerStocksAdvancedSell={immBrokerStocksAdvancedSell}
                        immStocksContract={immStocksContract}
                        immSearchState={immSearchState}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    handleOnClick = () => {
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_URL);
    }

    render() {
        const { immBrokerStocksAdvancedSell, immOpenTrader, immProductFile, immMyInvestments, immFlagBasedFeatures } = this.props;
        const showLinkForCountryFF = immFlagBasedFeatures.get('opentrader');
        const mappingBreadcrumb = this.getBreadcrumbData(immProductFile, this.props.match.params.isin, this.props.match.params.iso, this.props.match.params.emisionCode, this.props.match.params.valueCode);
        let contractBoxContent;
        if (immProductFile.get('isFetched')) {
            if (immBrokerStocksAdvancedSell.get('submitSuccessful')) {
                contractBoxContent = this.buildSuccessful();
            } else {
                contractBoxContent = this.buildWizard();
            }
        }


        return (
            <div className="broker-stocks-advanced-sell-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        className="broker-stocks-advanced-sell-view__header"
                        finalTitle={getFinalTitle('broker-stocksAdvancedSellViewTitle')}
                    >
                        <OKButton inverse={true} modifier="ghost" onClick={() => this.handleOnClick()}>
                            <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                        </OKButton>
                        <WebappRender>
                            {showLinkForCountryFF &&
                                <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                    <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                </OKButton>
                            }
                        </WebappRender>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-stocks-advanced-sell-view__body">
                    <BrokerStocksHeader
                        productFile={immProductFile}
                        immMyInvestments={immMyInvestments}
                        handleUpdate={this.getProductDetails}
                        noBottomButtons={true}
                    />
                    <div className="broker-stocks-advanced-sell-view__wizard">
                        {contractBoxContent}
                    </div>
                </section>
            </div>
        );
    }
}

BrokerStocksAdvancedSellView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerStocksAdvancedSell: PropTypes.object,
    immOpenTrader: PropTypes.object.isRequired,
    immProductFile: PropTypes.object,
    immProfile: PropTypes.object,
    immStocksContract: PropTypes.object,
    immSearchState: PropTypes.object,
    immMyInvestments: PropTypes.object.isRequired,
    reset: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    validateStep: PropTypes.func,
    finish: PropTypes.func,
    setLimitedValueCurrency: PropTypes.func,
    match: PropTypes.object,
    getProductDetails: PropTypes.func,
    setOrderID: PropTypes.func,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    getCollectivesCommissionsInfo: PropTypes.func,
    immCollectivesCommissions: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object,
}

module.exports.constructor = BrokerStocksAdvancedSellView;
module.exports.BrokerStocksAdvancedSellView = connect(
    state => ({
        immBrokerStocksAdvancedSell: state.brokerStocksAdvancedSell,
        immCollectivesCommissions: state.collectivesCommissions,
        immProductFile: state.brokerProductFile,
        immProfile: state.profile,
        immStocksContract: state.brokerStocksContract,
        immSearchState: state.brokerSearch,
        immMyInvestments: state.brokerMyInvestments,
        immOpenTrader: state.brokerOpenTrader,
        immVariables: state.globalVariables,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        reset: BrokerStocksAdvancedSellActions.reset,
        setVisibleStep: BrokerStocksAdvancedSellActions.setVisibleStep,
        setWillCancel: BrokerStocksAdvancedSellActions.setWillCancel,
        validateStep: BrokerStocksAdvancedSellActions.validateStep,
        finish: BrokerStocksAdvancedSellActions.finish,
        setLimitedValueCurrency: BrokerStocksAdvancedSellActions.setLimitedValueCurrency,
        getProductDetails: ProductFileActions.getProductFileWithCatalogData,
        setOrderID: BrokerStocksAdvancedSellActions.setOrderID,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo
    }
)(withRouter(BrokerStocksAdvancedSellView));
